module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pxii"
    }
  }), _c('a', {
    attrs: {
      "id": "pxiii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("F YOU WERE TO PERCH ON A TREETOP")]), _vm._v(" "), _c('em', [_vm._v("and look down on Fox Cove, you would see a gully, about twenty feet across and with a brook gurgling down its spine to the seashore below and flanked on either side by a sea of rippling grass, cresting with Queen Anne’s lace, and scented with a brew of burning birch, wet ground and kelp.")])]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_c('em', [_vm._v("To the right of the gully, and about a hundred yards down from a dirt road, is a grey, weather-beaten house, its windows opened to the sea, and its walls slanted back, as if beaten into the hillside by the easterly winds gusting off the Atlantic and whistling up the gully’s channel. And if you were to hop onto a windowsill and look inside that house, you would see three women. The eldest sits in a rocker by a fire-blistering wood stove, her iron-grey hair hanging down around her fat-padded shoulders, and a pinched look on her wrinkled old face as she sucks on something sharp. Standing behind her, drawing a comb through the grey tresses, is another, younger, with flaming red hair, a furrow deepening her brow, and her tongue nipped betwixt her teeth as she clumsily attempts to gather the old woman’s hair into a bun and fit it into a hairnet that she dangles from one finger. Sprawled across the daybed and watching the two is me, the youngest, with fine yellow hair falling away from my forehead, and a smile, I imagine, rounding the curve of my cheek as I watch.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d41e8850","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front05.vue
// module id = 72
// module chunks = 0